import React, { useEffect, useState } from 'react';
import { Box, Typography, Alert, Avatar, CircularProgress, Button, Grid } from '@mui/material';
import axios from 'axios';
import Announcement from './Announcement';
import { Crumbs } from '../Crumbs';

const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

const AnnouncementList = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  useEffect(() => {
    async function fetchAnnouncements() {
      setLoading(true);
      try {
        const res = await axios.get(`${BACKEND_HOST}/announcements?sort=createdAt:desc&populate[]=user_profile&populate[]=user_profile.pic`);
        const data = res.data?.data || res.data;
        setAnnouncements(Array.isArray(data) ? data : []);
      } catch (err) {
        setError('Failed to load announcements');
      } finally {
        setLoading(false);
      }
    }
    fetchAnnouncements();
  }, []);

  const truncateBody = (body, maxLength = 150) => {
    if (!body) return '';
    return body.length > maxLength ? `${body.substring(0, maxLength)}...` : body;
  };


  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Box sx={{ margin: 'auto' }}>
      <Crumbs crumbs={[{ title: 'Announcements' }]} />
      
      {announcements.length === 0 ? (
        <Typography>No announcements found.</Typography>
      ) : (
        <Grid container spacing={2} width="100%">
          {announcements.map((announcement) => {
            const { title, body, user_profile } = announcement;
            const user = user_profile;
            
            return (
              <Grid item xs={12} md={4} key={announcement.id}>
                <Announcement
                  announcement={announcement}
                  loading={false}
                  error={null} />
              </Grid>
            );
          })}
        </Grid>
      )} 
    </Box>
  );
};

export default AnnouncementList;